<template>
  <div>
    <el-tabs v-model="activeTab" @tab-change="onTabChange">
      <el-tab-pane label="日序与选图" name="day">
    <el-alert v-if="restorePreviewMode" type="warning" :closable="false" show-icon class="cm-restore-bar">
      <template #default>
        <p style="margin: 0 0 8px 0; line-height: 1.5">
          已用本页默认用户来源数据覆盖当前用户来源（仅本地）；点顶栏「入库」写入服务器，或点「取消」从服务器重新加载以放弃。
        </p>
        <el-button size="small" :disabled="loading" @click="cancelRestorePreview">取消</el-button>
      </template>
    </el-alert>
    <div style="display: flex;justify-content: space-between">
        <div>
            <el-button type="primary" :disabled="loading || restorePreviewMode" @click="openDialog">选图</el-button>
            <el-button :disabled="loading || restorePreviewMode" @click="openImportDialog" style="margin-left: 4px">批量导入</el-button>
            <el-button :disabled="loading || restorePreviewMode" @click="exportCurrentManualCsv" style="margin-left: 4px">批量导出</el-button>
            <el-select placeholder="新建国家分组" style="margin-left: 4px" :disabled="loading" @change="addCountry" filterable>
              <el-option v-for="c in $root.country_list" :key="c.code" :value="c.code"
                         :disabled="c.code === 'US' || countries.includes(c.code)"
                         :label="c.en_name + ' (' + c.code + ')'"></el-option>
            </el-select>
        </div>
        <div>
            <el-select v-model="form.platform" :disabled="loading || restorePreviewMode" @change="onBucketContextChange" placeholder="平台" filterable
                       clearable style="width: 150px; margin-right: 3px">
              <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
            </el-select>
            <el-select v-model="form.country" :disabled="loading || restorePreviewMode" @change="onBucketContextChange" placeholder="全球" filterable
                       clearable style="width: 220px">
              <el-option value="US" :label="countryLabel('US')"></el-option>
              <el-option v-for="c in countries" :key="c" :value="c" :label="countryLabel(c)"></el-option>
            </el-select>
            <el-select
              ref="sourceSelect"
              class="cm-source-select"
              :key="manualBucketKey"
              v-model="form.source" :disabled="loading || restorePreviewMode" @change="onSourceSelectChange" filterable
                       clearable placeholder="默认用户来源" style="width: 240px; margin-left: 4px">
              <el-option value="" label="默认用户来源"></el-option>
              <el-option v-for="k in mergedSourceOptions" :key="k" :value="k" :label="k"/>
              <template #footer>
                <div style="padding: 6px 12px; border-top: 1px solid var(--el-border-color-lighter)">
                  <el-button link :disabled="loading || restorePreviewMode" @click="openNewSourceDialog">新建用户来源</el-button>
                </div>
              </template>
            </el-select>
            <el-button
              v-if="isNonDefaultSource"
              type="danger"
              plain
              :disabled="loading || restorePreviewMode"
              @click="openDeleteSourceDialog"
              style="margin-left: 4px"
            >删除用户来源</el-button>
            <el-button
              v-if="isNonDefaultSource"
              :disabled="loading || restorePreviewMode"
              @click="startRestorePreview"
              style="margin-left: 4px"
            >恢复默认配置</el-button>
            <el-select v-model="form.label" :disabled="loading || restorePreviewMode" @change="onBucketContextChange" style="margin-left: 4px">
              <el-option v-for="l in labels" :value="l" :label="`方案${l}`"></el-option>
            </el-select>
            <!-- <el-select v-model="form.category_ids" :disabled="loading" @change="formatData" multiple clearable filterable
                       collapse-tags collapse-tags-tooltip placeholder="分类" style="width: 180px; margin-left: 3px">
              <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
            </el-select> -->
            <el-button
              type="primary"
              :disabled="loading || !canCommitSource"
              @click="commitCurrentSource"
              style="margin-left: 5px"
            >入库</el-button>
            <el-button
              type="success"
              :disabled="loading || sortSaving || !hasPendingSort"
              :loading="sortSaving"
              @click="commitPendingSort"
              style="margin-left: 5px"
            >{{ pendingSortCount ? `保存排序(${pendingSortCount})` : '保存排序' }}</el-button>
            <el-button
              v-if="selectedRookieCount"
              :disabled="loading"
              @click="clearRookieSelection"
              style="margin-left: 5px"
            >清除选择({{ selectedRookieCount }})</el-button>
            <el-button v-if="has_feature_rookie_apply" type="danger" :disabled="loading || restorePreviewMode" @click="openCopyDialog" style="margin-left: 5px">复制完整用户来源方案</el-button>
            <el-button v-if="has_feature_rookie_apply" type="danger" :disabled="loading || restorePreviewMode" @click="openCopySchemeDialog" style="margin-left: 5px">复制当前方案</el-button>
        </div>
    </div>
    <CountryManualSortableBoard
        :days="displayDays"
        :cdn-url="manualCdnUrl"
        :loading="loading"
        :selected-rookie-ids="selectedRookieIdSet"
        :selected-rookie-day="selectedRookieDay"
        @drag-start="onBoardDragStart"
        @reorder="onManualReorder"
        @drag-end="onRookieDragEnd"
        @select="onBoardSelect"
        @remove="remove"
    />
    <el-table
      style="margin-top: 10px"
      v-loading="loading"
      :data="pagedRookieFilter"
      row-key="image_id"
    >
      <el-table-column label="预览图" width="230">
        <template #default="scope">
          <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`" style="width: 100px"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" prop="image_id" width="180"></el-table-column>
      <el-table-column label="分类" prop="categories" width="120">
        <template #default="scope">
          <el-tag size="small" v-for="c in scope.row.categories" :key="c">{{ categoryName(c) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template #header>
	          <div class="cm-filter-header">
	            <span>激励视频</span>
	            <el-select v-model="rookieVideoFilter" clearable size="small" placeholder="全部" style="width: 78px">
	              <el-option label="Yes" :value="true"></el-option>
	              <el-option label="No" :value="false"></el-option>
	            </el-select>
	            <el-button
	              v-if="selectedVideoCount"
	              type="warning"
	              size="small"
	              :disabled="loading"
	              @click="batchCancelSelectedVideo"
	            >取消选中({{ selectedVideoCount }})</el-button>
	          </div>
	        </template>
	        <template #default="scope">
	          <template v-if="scope.row.cost > 0">
	            <el-checkbox
	              :model-value="isVideoSelected(scope.row)"
	              :disabled="loading"
	              @change="toggleVideoSelection(scope.row)"
	            />
	            <el-tag style="margin-left: 4px">{{"Yes"}}</el-tag>
	          </template>
	        </template>
	      </el-table-column>
      <el-table-column width="150">
        <template #header>
          <div class="cm-filter-header">
            <span>动图</span>
            <el-select v-model="rookieAnimationFilter" clearable size="small" placeholder="全部" style="width: 78px">
              <el-option label="Yes" :value="true"></el-option>
              <el-option label="No" :value="false"></el-option>
            </el-select>
          </div>
        </template>
        <template #default="scope">
          <el-tag v-if="hasAnimation(scope.row)" type="success">{{"Yes"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="天数" prop="day" width="180">
        <template #default="scope">
          <el-input-number v-model="scope.row.day" :disabled="loading"  @change="updateRookie(scope.row, true)"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="用户来源" width="120">
        <template #default="scope">
          <span>{{ displaySource(rowSource(scope.row)) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上线时间" prop="online_date" width="200"></el-table-column>
    </el-table>
    <el-pagination
      class="cm-rookie-table-pagination"
      layout="total, sizes, prev, pager, next"
      :total="rookieFilter.length"
      :page-size="rookieTablePageSize"
      :current-page="rookieTablePage"
      :page-sizes="[50, 100, 200, 500]"
      @current-change="onRookieTablePageChange"
      @size-change="onRookieTablePageSizeChange"
    />
      </el-tab-pane>
      <el-tab-pane label="用户来源映射" name="ad">
        <RookieAdFromMap ref="sourceMap" :valid-sources="mergedSourceOptions"/>
      </el-tab-pane>
    </el-tabs>
    <el-dialog v-model="dialog_opened" :before-close="closeDialog" width="80%">
        <el-form :model="form" label-width="100px" ref="form">
          <el-form-item label="天数" prop="day" :rules="[{required: true, message: '输入天数', type: 'number'}]">
            <el-input-number v-model="form.day" :disabled="loading"></el-input-number>
          </el-form-item>
          <el-form-item label="图片" prop="images" :rules="[{required: true, message: '请选择图片'}]">
            <template v-for="image in form.images">
              <el-image style="width: 160px; margin-left: 2px" :src="`${$root.cdn_url}/${image.thumbnail}`"></el-image>
            </template>
          </el-form-item>
        </el-form>
        <div style="display: flex; margin-bottom: 10px; flex-wrap: wrap; gap: 10px;">
          <el-input v-model="query.id" prefix-icon="Search" @blur="fetchImages(1)" placeholder="ID搜索" style="width: 200px;"></el-input>
          <el-select v-model="query.category_ids" multiple clearable filterable collapse-tags collapse-tags-tooltip
                     placeholder="分类筛选" style="width: 200px;" @change="fetchImages(1)">
            <el-option v-for="c in category_list" :value="c.id" :label="c.i18n_name.ZH_HANS"></el-option>
          </el-select>
          <el-cascader v-model="query.major_tags" placeholder="主要标签" clearable filterable 
                       :options="major_list" :props="tagProps" @change="fetchImages(1)" 
                       collapse-tags collapse-tags-tooltip style="width: 290px"></el-cascader>
          <el-cascader v-model="query.minor_tags" placeholder="次要标签" clearable filterable 
                       :options="minor_list" :props="tagProps" @change="fetchImages(1)" 
                       collapse-tags collapse-tags-tooltip style="width: 290px"></el-cascader>
          <el-cascader v-model="query.assistant_tags" placeholder="辅助标签" clearable filterable 
                       :options="assistant_list" :props="tagProps" @change="fetchImages(1)" 
                       collapse-tags collapse-tags-tooltip style="width: 290px"></el-cascader>
          <el-select v-model="query.source" placeholder="来源筛选" clearable filterable
                     style="width: 180px;" @change="fetchImages(1)">
            <el-option v-for="s in source_list" :key="s" :value="s" :label="s"></el-option>
          </el-select>
        </div>
        <el-table style="margin-top: 10px" v-loading="imagePickerLoading" :data="image_list">
            <el-table-column label="预览图" prop="prefix" width="230">
                <template #default="scope">
                    <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`" style="width: 100px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="ID" prop="id" width="150"></el-table-column>
            <el-table-column label="分类" prop="categories" width="120">
                <template #default="scope">
                    <el-tag size="small" v-for="c in scope.row.categories" :key="c">{{ categoryName(c) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="主要标签" prop="major_tags" width="100">
                <template #default="scope">
                    <el-tag v-for="t in scope.row.major_tags">{{ major_map[t] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="次要标签" prop="minor_tags" width="100">
                <template #default="scope">
                    <el-tag v-for="t in scope.row.minor_tags">{{ minor_map[t] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="辅助标签" prop="assistant_tags" width="100">
                <template #default="scope">
                    <el-tag v-for="t in scope.row.assistant_tags">{{ assistant_map[t] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="作者" prop="author" width="100"></el-table-column>
            <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-button type="primary" @click="addImage(scope.row)" size="small" :disabled="loading || isImagePickedOrAdded(scope.row)">
                    {{ isImagePickedOrAdded(scope.row) ? '已添加' : '添加' }} </el-button>
<!--                    <el-button type="primary" @click="addImage(scope.row)" :disabled="loading">添加</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page="page"
          :page-sizes="[10, 50, 100]"
          @current-change="fetchImages"
          @size-change="handleImagePageSizeChange"
          :disabled="imagePickerLoading"
        ></el-pagination>
        <template #footer>
            <el-button type="primary" :loading="loading" @click="closeDialog()" text>取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="dialog_opened_copy" width="30%" title="复制完整用户来源方案">
      <el-form label-width="140px">
        <el-form-item label="当前用户来源">
          <span>{{ displaySource(form.source) }}</span>
        </el-form-item>
        <el-form-item label="目标用户来源">
          <el-select v-model="form.target_source" :disabled="loading" filterable allow-create clearable
                     default-first-option placeholder="默认用户来源" style="width: 100%">
            <el-option value="" label="默认用户来源"></el-option>
            <el-option v-for="k in mergedSourceOptions" :key="k" :value="k" :label="k"/>
          </el-select>
        </el-form-item>
        <el-form-item label="目标国家">
          <el-select v-model="form.target_country" :disabled="loading" placeholder="全球" filterable style="width: 100%">
            <el-option value="US" :label="countryLabel('US')"></el-option>
            <el-option v-for="c in countries" :key="c" :value="c" :label="countryLabel(c)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标平台">
          <el-select v-model="form.target_platform" :disabled="loading" placeholder="Android" filterable style="width: 100%">
            <el-option v-for="p in ['android', 'ios']" :key="p" :value="p" :label="p"></el-option>
          </el-select>
        </el-form-item>
        <div style="color: var(--el-text-color-secondary); font-size: 12px; padding-left: 140px">
          将复制当前用户来源下方案 0/1/2 的全部新手图到目标用户来源；确认后立即写入服务器。
        </div>
      </el-form>
      <el-row style="justify-content: flex-end; margin-top: 10px">
        <el-button @click="dialog_opened_copy = false" :loading="loading">取消</el-button>
        <el-button @click="copyCurrentSourceToTarget" type="primary" :loading="loading">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-model="dialog_opened_copy_scheme" width="30%" title="复制当前方案">
      <el-form label-width="140px">
        <el-form-item label="目标方案">
          <el-checkbox-group v-model="form.target_labels" :disabled="loading">
            <el-checkbox v-for="i in labels" :key="i" :label="i">{{ `方案${i}` }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="目标用户来源">
          <el-select v-model="form.target_source" :disabled="loading" filterable allow-create clearable
                     default-first-option placeholder="默认用户来源" style="width: 100%">
            <el-option value="" label="默认用户来源"></el-option>
            <el-option v-for="k in mergedSourceOptions" :key="k" :value="k" :label="k"/>
          </el-select>
        </el-form-item>
        <el-form-item label="目标国家">
          <el-select v-model="form.target_country" :disabled="loading" placeholder="全球" filterable style="width: 100%">
            <el-option value="US" :label="countryLabel('US')"></el-option>
            <el-option v-for="c in countries" :key="c" :value="c" :label="countryLabel(c)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目标平台">
          <el-select v-model="form.target_platform" :disabled="loading" placeholder="Android" filterable style="width: 100%">
            <el-option v-for="p in ['android', 'ios']" :key="p" :value="p" :label="p"></el-option>
          </el-select>
        </el-form-item>
        <div style="color: var(--el-text-color-secondary); font-size: 12px; padding-left: 140px">
          将当前用户来源 + 当前方案复制到目标；确认后立即写入服务器。
        </div>
      </el-form>
      <el-row style="justify-content: flex-end; margin-top: 10px">
        <el-button @click="dialog_opened_copy_scheme = false" :loading="loading">取消</el-button>
        <el-button @click="copyFullSchemeToTarget" type="primary" :loading="loading">确认</el-button>
      </el-row>
    </el-dialog>
    <el-dialog v-model="dialog_opened_import" width="560px" title="批量导入日序">
      <el-alert
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
        :title="importMode === 'replace' ? '替换模式只替换 CSV 涉及的天，未涉及的天保持不变。' : '添加模式会把 CSV 图片加到对应天数的开头，当前已有图片保持不变。'"
      />
      <el-form label-width="90px">
        <el-form-item label="导入方式">
          <el-radio-group v-model="importMode">
            <el-radio label="replace">替换</el-radio>
            <el-radio label="append">添加</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="CSV 文件">
          <el-upload
            action="#"
            accept=".csv,text/csv"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onImportFileChange"
          >
            <el-button :disabled="loading">选择 CSV</el-button>
          </el-upload>
          <span v-if="importFileName" class="cm-import-file">{{ importFileName }}</span>
        </el-form-item>
        <el-form-item label="CSV 内容">
          <el-input
            v-model="importCsvText"
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 16 }"
            placeholder="day,image_id,分类,preview_url&#10;1,64abc...,动物,https://...&#10;1,64def...,建筑,https://...&#10;2,64ghi...,风景,https://..."
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialog_opened_import = false" :loading="loading">取消</el-button>
        <el-button type="primary" @click="submitImportCsv" :loading="loading">确认导入</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="newSourceDialog" title="新建用户来源" width="420px" @close="onNewSourceDialogClose">
      <p style="margin: 0 0 8px; color: var(--el-text-color-secondary); font-size: 13px">新建后先为空；在该用户来源下选图、改日序会即时写入服务器。</p>
      <el-input
        v-model="newSourceInput"
        placeholder="仅字母、数字、下划线、连字符；不可为 default"
        clearable
        @keyup.enter="confirmNewSource"
      />
      <template #footer>
        <el-button @click="newSourceDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmNewSource">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "ts-axios-new";
import CountryManualSortableBoard from './country-manual/CountryManualSortableBoard.vue'
import RookieAdFromMap from "./RookieAdFromMap.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {has_feature_rookie_apply} from "../libs/permission";

function apiError(e) {
  const m =
    e?.response?.data?.message ||
    e?.response?.data?.status?.message ||
    (typeof e?.response?.data === "string" ? e.response.data : null) ||
    e?.message;
  if (m) ElMessage.error(m);
  else ElMessage.error("请求失败");
}

export default {
    name: "CountryManual",
    components: { CountryManualSortableBoard, RookieAdFromMap },
    data() {
        return {
            newSourceDialog: false,
            newSourceInput: "",
            extraSources: [],
            restorePreviewMode: false,
            /** 已落库用户来源在「还原」前、待入库前删除的 row id 列表 */
            _restoreServerRowIds: [],
            /** 在「默认用户来源」下最后一次 init 得到的默认桶快照，供恢复默认配置深复制 */
            defaultRookieCache: [],
            _defaultRookieBox: null,
            /** 切换国家/平台/方案时改用户来源会触发 @change，避免连续两次 init */
            _ignoreSourceInitOnce: false,
            /** 程序化切桶（如复制后跳转）时，临时跳过 watch 清空本地草稿 */
            _skipBucketWatchReset: false,
            pendingSortByDay: {},
            sortSaving: false,
            sortAutoSaveTimer: null,
            sortSavePromise: null,
            imagePickerLoading: false,
	            selectedRookieIds: [],
	            selectedRookieDay: null,
            selectedVideoImageIds: [],
            rookieVideoFilter: null,
            rookieAnimationFilter: null,
            rookieTablePage: 1,
            rookieTablePageSize: 100,
            dialog_opened_import: false,
            importCsvText: "",
            importFileName: "",
            importMode: "replace",
            groupDragState: null,
            suppressRookieClick: false,
            loading: false, data: [], image_list: [],
            currentRookieRows: [],
            category_list: [], major_list: [], minor_list: [], assistant_list: [],
            category_map: {}, major_map: {}, minor_map: {}, assistant_map: {}, source_list: [],
            dialog_opened: false, rookie: [], dialog_opened_copy: false, dialog_opened_copy_scheme: false,
            activeTab: "day",
            // params: {id: '', status: 'AUDITED', module: 'LIBRARY'},
            labels: [0, 1, 2], countries: [], total: 0, page: 1, rookie_set: new Set(),
            sourceSuggestions: [],
            form: {
                day: 0,
                country: 'US',
                platform: 'android',
                label: 0,
                source: '',
                category_ids: [],
                images: [],
                target_country: null,
                target_platform: 'android',
                target_labels: [],
                target_source: "",
            },
            query: {
              status: 'AUDITED',
              id: "",
              source: "",
              category_ids: [],
              major_tags: null,
              minor_tags: null,
              assistant_tags: null,
              skip: 0,
              limit: 10,
            },
            tagProps: {expandTrigger: 'hover', label: 'name', value: 'id', emitPath: false, multiple: true},
        }
    },
    methods: {
      has_feature_rookie_apply,
        /** 与后端 normalize_stored_source 一致：strip；空或 default（大小写不敏感）视为默认桶 */
        normSource(s) {
          if (s == null || s === '') return '';
          const t = String(s).trim();
          if (!t || t.toLowerCase() === 'default') return '';
          return t;
        },
        displaySource(s) {
          return this.normSource(s) || '默认';
        },
        rowSource(r) {
          if (!r) return '';
          return this.normSource(r.source);
        },
        assignSourceFields(obj, sourceVal) {
          obj.source = this.normSource(sourceVal);
          return obj;
        },
        withManualSource(payload, sourceVal) {
          payload.source = this.normSource(sourceVal);
          return payload;
        },
        hasAnimation(row) {
          return !!(row && row.animation);
        },
        isBoolFilterActive(value) {
          return value === true || value === false;
        },
        openImportDialog() {
          this.importCsvText = "";
          this.importFileName = "";
          this.importMode = "replace";
          this.dialog_opened_import = true;
        },
        onTabChange(name) {
          if (name === "ad" && this.$refs.sourceMap && this.$refs.sourceMap.init) {
            this.$refs.sourceMap.init();
          }
        },
        onImportFileChange(file) {
          const raw = file && file.raw ? file.raw : null;
          if (!raw) return;
          this.importFileName = raw.name || "";
          const reader = new FileReader();
          reader.onload = (e) => {
            this.importCsvText = (e.target && e.target.result) || "";
          };
          reader.onerror = () => {
            ElMessage.error("CSV 文件读取失败");
          };
          reader.readAsText(raw);
        },
        parseImportCsvLine(line) {
          const cols = [];
          let cell = "";
          let inQuote = false;
          for (let i = 0; i < line.length; i += 1) {
            const ch = line[i];
            if (ch === '"') {
              if (inQuote && line[i + 1] === '"') {
                cell += '"';
                i += 1;
              } else {
                inQuote = !inQuote;
              }
            } else if (ch === "," && !inQuote) {
              cols.push(cell.trim());
              cell = "";
            } else {
              cell += ch;
            }
          }
          cols.push(cell.trim());
          return cols;
        },
        parseImportCsv(text) {
          const rawLines = String(text || "")
            .replace(/^\uFEFF/, "")
            .split(/\r?\n/)
            .map((line) => line.trim())
            .filter(Boolean);
          if (!rawLines.length) {
            throw new Error("请粘贴或上传 CSV 内容");
          }
          let lines = rawLines;
          const first = this.parseImportCsvLine(rawLines[0]).map((x) => x.toLowerCase());
          if (first[0] === "day" && first[1] === "image_id") {
            lines = rawLines.slice(1);
          }
          if (!lines.length) {
            throw new Error("CSV 中没有可导入的数据行");
          }
          const items = [];
          const seenImages = new Set();
          for (let i = 0; i < lines.length; i += 1) {
            const rowNo = rawLines.length === lines.length ? i + 1 : i + 2;
            const cols = this.parseImportCsvLine(lines[i]);
            if (cols.length < 2) {
              throw new Error(`第 ${rowNo} 行格式不正确，需要 day,image_id`);
            }
            const dayRaw = cols[0];
            const imageId = String(cols[1] || "").trim();
            const dayNum = Number(dayRaw);
            if (!Number.isInteger(dayNum) || dayNum < 0) {
              throw new Error(`第 ${rowNo} 行 day 必须是非负整数`);
            }
            if (!imageId) {
              throw new Error(`第 ${rowNo} 行 image_id 不能为空`);
            }
            if (seenImages.has(imageId)) {
              throw new Error(`第 ${rowNo} 行 image_id 重复：${imageId}`);
            }
            seenImages.add(imageId);
            items.push({day: dayNum, image_id: imageId});
          }
          return items;
        },
        csvEscape(value) {
          const text = value == null ? "" : String(value);
          if (/[",\r\n]/.test(text)) {
            return `"${text.replace(/"/g, '""')}"`;
          }
          return text;
        },
        categoryName(id) {
          return this.category_map[id] || id || "";
        },
        categoryText(row) {
          return (row && row.categories ? row.categories : [])
            .map((id) => this.categoryName(id))
            .filter(Boolean)
            .join("|");
        },
        previewUrl(row) {
          const thumbnail = row && row.thumbnail ? String(row.thumbnail) : "";
          if (!thumbnail) return "";
          if (/^https?:\/\//i.test(thumbnail)) return thumbnail;
          const base = (this.$root.cdn_url || "").replace(/\/$/, "");
          const path = thumbnail.replace(/^\//, "");
          return base ? `${base}/${path}` : path;
        },
        downloadCsv(filename, rows) {
          const csv = rows.map((row) => row.map((cell) => this.csvEscape(cell)).join(",")).join("\n");
          const blob = new Blob([`\uFEFF${csv}`], {type: "text/csv;charset=utf-8"});
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        },
        exportCurrentManualCsv() {
          const rows = this.currentManualRows()
            .slice()
            .sort(
              (a, b) =>
                Number(a.day || 0) - Number(b.day || 0) ||
                Number(a.sort || 0) - Number(b.sort || 0) ||
                String(a.image_id || "").localeCompare(String(b.image_id || ""))
            );
          if (!rows.length) {
            ElMessage.warning("当前方案没有可导出的日序");
            return;
          }
          const csvRows = [["day", "image_id", "分类", "preview_url"]];
          rows.forEach((row) => {
            csvRows.push([
              row.day,
              row.image_id,
              this.categoryText(row),
              this.previewUrl(row),
            ]);
          });
          const source = this.normSource(this.form.source) || "default";
          const name = `manual_${this.form.platform || "android"}_${this.form.country || "US"}_label${this.form.label}_${source}.csv`;
          this.downloadCsv(name, csvRows);
          ElMessage.success(`已导出 ${rows.length} 条日序`);
        },
        buildImportSubmitItems(items, mode, currentRows) {
          if (mode === "replace") {
            return items;
          }
          const currentByDay = new Map();
          currentRows.forEach((row) => {
            const day = Number(row.day || 0);
            if (!currentByDay.has(day)) currentByDay.set(day, []);
            currentByDay.get(day).push(row);
          });
          currentByDay.forEach((rows) => {
            rows.sort(
              (a, b) =>
                Number(a.sort || 0) - Number(b.sort || 0) ||
                String(a.image_id || "").localeCompare(String(b.image_id || ""))
            );
          });
          const csvByDay = new Map();
          const dayOrder = [];
          items.forEach((item) => {
            const day = Number(item.day || 0);
            if (!csvByDay.has(day)) {
              csvByDay.set(day, []);
              dayOrder.push(day);
            }
            csvByDay.get(day).push(item);
          });
          const merged = [];
          dayOrder.forEach((day) => {
            merged.push(...(csvByDay.get(day) || []));
            (currentByDay.get(day) || []).forEach((row) => {
              merged.push({day, image_id: String(row.image_id)});
            });
          });
          return merged;
        },
        async submitImportCsv() {
          while (this.sortSavePromise || this.hasPendingSort) {
            const sortSaved = await this.commitPendingSort({silent: true});
            if (!sortSaved) {
              ElMessage.error("排序保存失败，未执行批量导入，请重试");
              return;
            }
          }
          let items = [];
          try {
            items = this.parseImportCsv(this.importCsvText);
          } catch (e) {
            ElMessage.error(e.message || "CSV 解析失败");
            return;
          }
          const currentRows = this.currentManualRows();
          const affectedDays = new Set(items.map((item) => Number(item.day)));
          const removeRows = currentRows.filter((row) => affectedDays.has(Number(row.day)));
          const currentImageIds = new Set(currentRows.map((row) => String(row.image_id)));
          if (this.importMode === "replace") {
            const keptImageIds = new Set(
              currentRows
                .filter((row) => !affectedDays.has(Number(row.day)))
                .map((row) => String(row.image_id))
            );
            const duplicated = items.filter((item) => keptImageIds.has(String(item.image_id)));
            if (duplicated.length) {
              ElMessage.error(`CSV 中有 ${duplicated.length} 张图片已存在于未替换的天数中，替换模式不可重复添加`);
              return;
            }
          }
          if (this.importMode === "append") {
            const duplicated = items.filter((item) => currentImageIds.has(String(item.image_id)));
            if (duplicated.length) {
              ElMessage.error(`CSV 中有 ${duplicated.length} 张图片已在当前方案中，添加模式不可重复添加`);
              return;
            }
          }
          const submitItems = this.buildImportSubmitItems(items, this.importMode, currentRows);
          try {
            await ElMessageBox.confirm(
              this.importMode === "replace"
                ? `将导入 ${items.length} 条日序，并替换 ${affectedDays.size} 天内已有的 ${removeRows.length} 条图片；未涉及天数保持不变，是否继续？`
                : `将在 ${affectedDays.size} 天内添加 ${items.length} 条日序，新图片会排在对应 day 的开头，原图片保持在后面，是否继续？`,
              "批量导入日序",
              {type: "warning"},
            );
          } catch (e) {
            return;
          }
          this.loading = true;
          try {
            await axios.post("/cms/v1/country/manual/batch", this.withManualSource({
              label: this.form.label,
              country: this.form.country,
              platform: this.form.platform,
              remove_ids: removeRows.map((row) => row.id).filter(Boolean),
              items: submitItems,
            }, this.form.source));
            this.restorePreviewMode = false;
            this._restoreServerRowIds = [];
            this.dialog_opened_import = false;
            await this.init();
            ElMessage.success(`已${this.importMode === "replace" ? "替换导入" : "追加导入"} ${items.length} 条日序`);
          } catch (e) {
            apiError(e);
          } finally {
            this.loading = false;
          }
        },
        currentManualRows() {
          return this.currentRookieRows || [];
        },
        /** 仅属于当前「平台+国家+方案」桶的 image 行（接口偶发混杂时二次过滤） */
        rowInCurrentManualBucket(r) {
          if (!r) return false;
          const rowL = r.label != null && r.label !== '' ? r.label : 0;
          const formL = this.form.label != null && this.form.label !== '' ? this.form.label : 0;
          if (Number(rowL) !== Number(formL)) return false;
          if ((r.country || 'US') !== (this.form.country || 'US')) return false;
          if ((r.platform || 'android') !== (this.form.platform || 'android')) return false;
          return true;
        },
        /** 切换国家/平台/方案时用户来源必须重置，避免仍指向上一桶 */
        onBucketContextChange() {
          this._ignoreSourceInitOnce = true;
          this.form.source = '';
          this.init();
          setTimeout(() => {
            this._ignoreSourceInitOnce = false;
          }, 0);
        },
        onSourceSelectChange() {
          if (this._ignoreSourceInitOnce) {
            this._ignoreSourceInitOnce = false;
            return;
          }
          this.init();
        },
        loadSourceSuggestions() {
          const params = {};
          if (this.form.platform) params.platform = this.form.platform;
          if (this.form.country) params.country = this.form.country;
          if (this.form.label !== undefined && this.form.label !== null) params.label = this.form.label;
          axios.get(`/cms/v1/country/manual`, { params }).then(res => {
            const set = new Set();
            (res.data.data.imageList || []).forEach((r) => {
              if (!this.rowInCurrentManualBucket(r)) return;
              const k = this.rowSource(r);
              if (k) set.add(k);
            });
            this.sourceSuggestions = Array.from(set);
            this.sanitizeSourceSelection();
          }).catch((e) => { apiError(e); });
        },
        /** 当前选中的用户来源若不在当前桶的可选列表中，则回到默认 */
        sanitizeSourceSelection() {
          const k = this.normSource(this.form.source);
          if (!k) return;
          const allowed = this.mergedSourceOptions;
          if (allowed.includes(k)) return;
          this.form.source = '';
        },
        bucketParams() {
          const p = {};
          if (this.form.platform) p.platform = this.form.platform;
          if (this.form.country) p.country = this.form.country;
          if (this.form.label !== undefined && this.form.label !== null) p.label = this.form.label;
          return p;
        },
        openNewSourceDialog() {
          if (this.$refs.sourceSelect) {
            this.$refs.sourceSelect.blur();
          }
          this.newSourceInput = "";
          this.newSourceDialog = true;
        },
        onNewSourceDialogClose() {
          this.newSourceInput = "";
        },
        async startRestorePreview() {
          if (!this.isNonDefaultSource) return;
          const k = this.normSource(this.form.source);
          this._restoreServerRowIds = (this.rookie || [])
            .filter(
              (r) =>
                r &&
                r.id &&
                this.rowSource(r) === k &&
                this.rowInCurrentManualBucket(r)
            )
            .map((r) => r.id);
          this.loading = true;
          try {
            const box = (this.form.platform || "android") + "|" + (this.form.country || "US") + "|" + (this.form.label != null ? this.form.label : 0);
            if (!this.defaultRookieCache.length || this._defaultRookieBox !== box) {
              const params = this.bucketParams();
              const res = await axios.get("/cms/v1/country/manual", { params });
              const all = res.data.data.imageList || [];
              this.defaultRookieCache = all
                .filter(
                  (r) =>
                    this.rowInCurrentManualBucket(r) &&
                    !this.rowSource(r)
                )
                .map((r) => JSON.parse(JSON.stringify(r)));
              this._defaultRookieBox = box;
            }
            const baseRows = this.buildNewSourceRowsFromDefaultTemplate(k);
            if (!baseRows.length) {
              ElMessage.warning("无默认用户来源数据可覆盖，请先在「默认用户来源」下切换本桶，或点「选图/切换」以拉取默认数据到缓存后重试。");
              this._restoreServerRowIds = [];
              return;
            }
            this.rookie = baseRows;
            this.restorePreviewMode = true;
            this.formatData();
            this.refreshAdded();
          } catch (e) {
            apiError(e);
            this._restoreServerRowIds = [];
          } finally {
            this.loading = false;
          }
        },
        cancelRestorePreview() {
          this.restorePreviewMode = false;
          this._restoreServerRowIds = [];
          this.init();
        },
        openDeleteSourceDialog() {
          if (!this.isNonDefaultSource) return;
          const k = this.normSource(this.form.source);
          if (!k) {
            ElMessage.warning("不能删除默认用户来源");
            return;
          }
          ElMessageBox.confirm(
            `确认删除用户来源「${k}」在当前国家/平台下方案 0/1/2 的全部新手图？`,
            "删除用户来源",
            { type: "warning" },
          )
            .then(() => {
              this.loading = true;
              return axios.post("/cms/v1/country/manual/delete-source", this.withManualSource({
                country: this.form.country,
                platform: this.form.platform,
              }, this.form.source));
            })
            .then(() => {
              ElMessage.success("已删除用户来源");
              this.extraSources = (this.extraSources || []).filter((x) => x !== k);
              this.form.source = "";
              this.restorePreviewMode = false;
              this._restoreServerRowIds = [];
              this.init();
            })
            .catch((e) => {
              if (e !== "cancel" && e !== "close") apiError(e);
            })
            .finally(() => {
              this.loading = false;
            });
        },
        refreshDefaultRookieCacheFromRookie() {
          const box = (this.form.platform || "android") + "|" + (this.form.country || "US") + "|" + (this.form.label != null ? this.form.label : 0);
          this._defaultRookieBox = box;
          this.defaultRookieCache = (this.rookie || [])
            .filter(
              (r) =>
                r &&
                this.rowInCurrentManualBucket(r) &&
                !this.rowSource(r)
            )
            .map((r) => JSON.parse(JSON.stringify(r)));
        },
        buildNewSourceRowsFromDefaultTemplate(k) {
          const skNum = (r) => (r.sort != null ? r.sort : 0);
          const dayNum = (x) => {
            const n = Number(x == null || x === "" ? 0 : x);
            return Math.trunc(Number.isFinite(n) ? n : 0);
          };
          const ordered = [...(this.defaultRookieCache || [])].sort(
            (a, b) =>
              dayNum(a.day) - dayNum(b.day) ||
              skNum(a) - skNum(b) ||
              String(a.image_id || "").localeCompare(String(b.image_id || ""))
          );
          const seen = new Set();
          const uniq = [];
          for (const r of ordered) {
            const id = r.image_id != null ? String(r.image_id).trim() : "";
            if (!id || seen.has(id)) continue;
            seen.add(id);
            uniq.push(r);
          }
          return uniq.map((r) => this.assignSourceFields({
            ...r,
            id: undefined,
            _localOnly: true,
            label: this.form.label,
            country: this.form.country,
            platform: this.form.platform,
            sort: skNum(r),
          }, k));
        },
        async confirmNewSource() {
          const k = (this.newSourceInput || "").trim();
          if (!k) {
            ElMessage.warning("请输入用户来源");
            return;
          }
          if (/^default$/i.test(k)) {
            ElMessage.warning("不能使用 default（不区分大小写）作为用户来源名");
            return;
          }
          if (!/^[a-zA-Z0-9_-]+$/.test(k)) {
            ElMessage.warning("仅支持字母、数字、下划线和连字符");
            return;
          }
          if (this.mergedSourceOptions.includes(k)) {
            ElMessage.info("该用户来源已存在，已切换到此来源");
            this.form.source = k;
            this.newSourceDialog = false;
            this.newSourceInput = "";
            this.init();
            return;
          }
          if (!(this.extraSources || []).includes(k)) {
            this.extraSources = [...(this.extraSources || []), k];
          }
          this.form.source = k;
          this.rookie = [];
          this.restorePreviewMode = false;
          this._restoreServerRowIds = [];
          this.newSourceDialog = false;
          this.newSourceInput = "";
          this.formatData();
          this.refreshAdded();
          this.loadSourceSuggestions();
        },
        async commitCurrentSource() {
          const k = this.normSource(this.form.source);
          if (!k) {
            ElMessage.warning("默认用户来源无需「入库」");
            return;
          }
          if (!this.restorePreviewMode) {
            ElMessage.info("「入库」仅用于「恢复默认配置」后的预览草稿。日常编辑会即时请求接口。");
            return;
          }
          this.loading = true;
          try {
            const rows = (this.rookie || []).filter((r) => this.rowSource(r) === k);
            if (!rows.length) {
              ElMessage.warning("无选图数据，无法入库");
              return;
            }
            const removeIds = (this._restoreServerRowIds || []).filter(Boolean);
            const pushed = await this.pushLocalSourceToServer(k, rows, removeIds);
            if (!pushed) {
              return;
            }
            this._restoreServerRowIds = [];
            this.restorePreviewMode = false;
            ElMessage.success("已入库");
            await this.init();
          } catch (e) {
            apiError(e);
          } finally {
            this.loading = false;
          }
        },
        async pushLocalSourceToServer(source, rows, removeIds) {
          const k = this.normSource(source);
          const labelNum = parseInt(this.form.label, 10);
          const label = Number.isNaN(labelNum) ? 0 : labelNum;
          const country = this.form.country == null || this.form.country === "" ? "US" : String(this.form.country);
          const platform = this.form.platform == null || this.form.platform === "" ? "android" : String(this.form.platform);
          const ordered = (rows || [])
            .slice()
            .sort(
              (a, b) =>
                (a.day - b.day) ||
                ((a.sort || 0) - (b.sort || 0)) ||
                String(a.image_id).localeCompare(String(b.image_id))
            );
          const items = [];
          for (const r of ordered) {
            if (r == null || r.image_id == null || r.image_id === "") continue;
            const imageId = String(r.image_id).trim();
            if (!imageId) continue;
            const dayNum = Number(r.day == null || r.day === "" ? 0 : r.day);
            const day = Math.trunc(Number.isNaN(dayNum) ? 0 : dayNum);
            if (!Number.isFinite(day)) continue;
            items.push({ day, image_id: imageId });
          }
          if (!items.length) {
            ElMessage.warning("无有效选图行，未发起入库");
            return false;
          }
          const rid = removeIds && removeIds.length ? removeIds.map((x) => String(x)) : [];
          await axios.post("/cms/v1/country/manual/batch", this.withManualSource({
            label,
            country,
            platform,
            remove_ids: rid,
            items,
          }, k));
          return true;
        },
        convertTagNames(list) {
        list.forEach(l => {
          l.name = l.i18n_name?.ZH_HANS || l.name;
          if (!l.children) {
            l.children = [];
          }
          if (l.children.length) {
            this.convertTagNames(l.children);
          }
        });
        },
        init() {
            this.clearSortAutoSave();
            this.pendingSortByDay = {};
            this.clearRookieSelection();
            this.clearVideoSelection();
            this.loading = true;
            const params = {};
            if (this.form.platform) params.platform = this.form.platform;
            if (this.form.country) params.country = this.form.country;
            if (this.form.label !== undefined && this.form.label !== null) params.label = this.form.label;
            if (this.form.source) {
              params.source = this.form.source;
            }
            if (this.form.category_ids && this.form.category_ids.length > 0) {
                params.category_ids = this.form.category_ids.join(',');
            }
            axios.get(`/cms/v1/country/manual`, {params}).then(res => {
                this.rookie = res.data.data.imageList;
                if (!this.form.source) {
                  this.refreshDefaultRookieCacheFromRookie();
                }
            }).then(_ => {
                this.loading = false;
                this.formatData();
                this.refreshAdded();
                this.loadSourceSuggestions();
            }).catch((e) => {
                apiError(e);
                this.loading = false;
            });
        },
        openDialog() {
            this.dialog_opened = true;
            this.form.images = []
            this.form.day = 0
            this.query.id = '';
            this.query.category_ids = this.form.category_ids ? [...this.form.category_ids] : [];
            this.query.major_tags = null;
            this.query.minor_tags = null;
            this.query.assistant_tags = null;
            this.query.source = "";
            this.query.limit = this.query.limit || 10;
            this.fetchImages(1)
        },
        openCopyDialog() {
          if (this.restorePreviewMode) {
            ElMessage.warning("请先对「默认覆盖」执行「入库」或「取消」");
            return;
          }
          this.form.target_country = this.form.country;
          this.form.target_platform = this.form.platform || 'android';
          this.form.target_source = '';
          this.dialog_opened_copy = true;
        },
        openCopySchemeDialog() {
          if (this.restorePreviewMode) {
            ElMessage.warning("请先对「默认覆盖」执行「入库」或「取消」");
            return;
          }
          const sourceLabel = this.form.label != null ? this.form.label : 0;
          this.form.target_labels = this.labels.filter((l) => l !== sourceLabel);
          this.form.target_country = this.form.country;
          this.form.target_platform = this.form.platform || 'android';
          this.form.target_source = this.form.source || '';
          this.dialog_opened_copy_scheme = true;
        },
        async copyCurrentSourceToTarget() {
          const source = this.normSource(this.form.source);
          const targetSource = this.normSource(this.form.target_source);
          const targetCountry = this.form.target_country || this.form.country;
          const targetPlatform = this.form.target_platform || this.form.platform || 'android';
          if (source === targetSource
              && targetCountry === this.form.country
              && targetPlatform === (this.form.platform || 'android')) {
            ElMessage.warning('目标和当前用户来源相同');
            return;
          }
          this.loading = true;
          try {
            const body = {
              country: this.form.country,
              platform: this.form.platform || 'android',
              target_country: targetCountry,
              target_platform: targetPlatform,
            };
            if (source) body.source = source;
            if (targetSource) body.target_source = targetSource;
            await axios.post(`/cms/v1/copy/country/manual/source`, body);
            if (targetSource && !(this.extraSources || []).includes(targetSource)
                && !(this.mergedSourceOptions || []).includes(targetSource)) {
              this.extraSources = [...(this.extraSources || []), targetSource];
            }
            this.dialog_opened_copy = false;
            await this.init();
            ElMessage.success('已复制完整用户来源方案');
          } catch (e) {
            apiError(e);
          } finally {
            this.loading = false;
          }
        },
        async copyFullSchemeToTarget() {
          if (!this.form.target_labels || !this.form.target_labels.length) {
            ElMessage.warning('请选择目标方案');
            return;
          }
          this.loading = true;
          try {
            const source = this.normSource(this.form.source);
            const targetSource = this.normSource(this.form.target_source);
            const body = {
              label: this.form.label != null ? this.form.label : 0,
              country: this.form.country,
              platform: this.form.platform || 'android',
              target_labels: this.form.target_labels.join(','),
              target_country: this.form.target_country || this.form.country,
              target_platform: this.form.target_platform || this.form.platform || 'android',
            };
            if (source) body.source = source;
            if (targetSource) body.target_source = targetSource;
            const res = await axios.post(`/cms/v1/copy/country/manual/label`, body);
            if (targetSource && !(this.extraSources || []).includes(targetSource)
                && !(this.mergedSourceOptions || []).includes(targetSource)) {
              this.extraSources = [...(this.extraSources || []), targetSource];
            }
            this.dialog_opened_copy_scheme = false;
            await this.init();
            const count = (res.data.data || {}).manual_count || (res.data.data || {}).count || 0;
            ElMessage.success(count ? `已复制当前方案：日序 ${count} 条` : '已复制当前方案');
          } catch (e) {
            apiError(e);
          } finally {
            this.loading = false;
          }
        },
        fetchImages(page) {
          this.query.skip = (page - 1) * this.query.limit;
          this.page = page
          this.imagePickerLoading = true;
          const params = {...this.query};
          if (!params.source) {
              delete params.source;
          }
          if (params.category_ids && params.category_ids.length > 0) {
              params.category_ids = params.category_ids.join(',');
          } else {
              delete params.category_ids;
          }
          if (params.major_tags && params.major_tags.length > 0) {
              params.major_tags = params.major_tags.join(',');
          } else {
              delete params.major_tags;
          }
          if (params.minor_tags && params.minor_tags.length > 0) {
              params.minor_tags = params.minor_tags.join(',');
          } else {
              delete params.minor_tags;
          }
          if (params.assistant_tags && params.assistant_tags.length > 0) {
              params.assistant_tags = params.assistant_tags.join(',');
          } else {
              delete params.assistant_tags;
          }
          axios.get(`/cms/v1/image`, {params}).then(res => {
            this.image_list = res.data.data.imageList;
            this.total = res.data.data.total;
            this.imagePickerLoading = false;
            this.refreshAdded();
          }).catch((e) => {
            this.imagePickerLoading = false;
            apiError(e);
          })
        },
        handleImagePageSizeChange(size) {
          this.query.limit = size;
          this.fetchImages(1);
        },
        formatData() {
            this.data = [];
            this.currentRookieRows = [];
            this.rookie_set = new Set()
            this.rookie.forEach(r => {
                if (!r.label) {
                  r.label = 0
                }
                if (!r.country) {
                  r.country = "US"
                }
                if (!r.platform) {
                  r.platform = "android"
                }
                if (!this.countries.includes(r.country) && r.country !== "GLOBAL" && r.country !== "US") {
                    this.countries.push(r.country);
                }
                if (this.rowInCurrentManualBucket(r) && this.rowSource(r) === this.normSource(this.form.source)) {
                  this.currentRookieRows.push(r);
                  this.rookie_set.add(String(r.image_id));
                  if (!this.data[r.day]) {
                    this.data[r.day] = {day: r.day, images: []}
                  }
                  this.data[r.day].images.push(r);
                }
            });
            this.data.forEach(d => {
              d.images.sort(function (a, b) {
                return a.sort - b.sort;
              })
            })
        },
        refreshAdded() {
          this.image_list.forEach(image => {
            image.added = this.isImageAddedToCurrentBucket(image);
          });
        },
        isImageAddedToCurrentBucket(image) {
          const id = image && image.id ? String(image.id) : "";
          return !!id && this.rookie_set.has(id);
        },
        isImagePickedOrAdded(image) {
          if (!image || !image.id) return false;
          const id = String(image.id);
          return this.isImageAddedToCurrentBucket(image) || this.form.images.findIndex((i) => String(i.id) === id) !== -1;
        },
        reset() {
          if (this.$refs.form) {
            this.$refs.form.resetFields();
          }
          this.form.images = [];
          this.dialog_opened = this.loading = false;
          this.dialog_opened_copy = false;
          this.refreshAdded()
        },
        // 选图弹窗：已从图库选好图片但还没保存时，关闭前先问是否保存，避免误关丢图。
        closeDialog(done) {
          const finish = () => {
            this.reset();
            if (typeof done === "function") {
              done();
            }
          };
          if (this.loading) {
            ElMessage.warning("正在保存，请稍候");
            return;
          }
          const pending = (this.form.images || []).length;
          if (!pending) {
            finish();
            return;
          }
          ElMessageBox.confirm(
            `已从图库选择 ${pending} 张图片，尚未保存。是否保存后关闭？`,
            "图片尚未保存",
            {
              confirmButtonText: "保存并关闭",
              cancelButtonText: "不保存",
              distinguishCancelAndClose: true,
              type: "warning",
            },
          ).then(() => {
            // 保存成功时 submit() 内部会 reset 并关闭弹窗；校验不通过或接口报错时保持弹窗，避免丢图。
            this.submit();
          }).catch((action) => {
            if (action === "cancel") {
              // 明确点了「不保存」才丢弃已选图片。
              finish();
            }
            // 否则是右上角 X / ESC：继续留在弹窗里编辑。
          });
        },
        rookieSelectKey(rookie) {
          if (!rookie) return "";
          return String(rookie.id || rookie.image_id || "");
        },
        rookieDayKey(dayData) {
          return String(dayData && dayData.day != null ? dayData.day : "");
        },
        isRookieSelected(dayData, rookie) {
          const dayKey = this.rookieDayKey(dayData);
          const key = this.rookieSelectKey(rookie);
          return !!key && this.selectedRookieDay === dayKey && this.selectedRookieIds.includes(key);
        },
        toggleRookieSelection(dayData, rookie) {
          if (this.loading || this.suppressRookieClick) return;
          const dayKey = this.rookieDayKey(dayData);
          const key = this.rookieSelectKey(rookie);
          if (!key) return;
          if (this.selectedRookieDay !== dayKey) {
            this.selectedRookieDay = dayKey;
            this.selectedRookieIds = [];
          }
          if (this.selectedRookieIds.includes(key)) {
            this.selectedRookieIds = this.selectedRookieIds.filter((id) => id !== key);
          } else {
            this.selectedRookieIds = [...this.selectedRookieIds, key];
          }
          if (!this.selectedRookieIds.length) {
            this.selectedRookieDay = null;
          }
        },
        clearRookieSelection() {
          this.selectedRookieIds = [];
          this.selectedRookieDay = null;
          this.groupDragState = null;
        },
        resetRookieTablePage() {
          this.rookieTablePage = 1;
        },
        onRookieTablePageChange(page) {
          this.rookieTablePage = page;
        },
        onRookieTablePageSizeChange(size) {
          this.rookieTablePageSize = size;
          this.rookieTablePage = 1;
        },
        removeRookieFromSelection(rookie) {
          const key = this.rookieSelectKey(rookie);
          if (!key || !this.selectedRookieIds.includes(key)) return;
          this.selectedRookieIds = this.selectedRookieIds.filter((id) => id !== key);
          if (!this.selectedRookieIds.length) {
            this.selectedRookieDay = null;
          }
        },
	        selectedRookieRows() {
	          const selected = new Set(this.selectedRookieIds || []);
	          if (!selected.size) {
	            return [];
	          }
	          return (this.rookie || []).filter((row) => selected.has(this.rookieSelectKey(row)));
	        },
	        videoSelectKey(row) {
	          return String(row && row.image_id ? row.image_id : "");
	        },
	        isVideoSelected(row) {
	          const key = this.videoSelectKey(row);
	          return !!key && this.selectedVideoImageIds.includes(key);
	        },
	        toggleVideoSelection(row) {
	          const key = this.videoSelectKey(row);
	          if (!key) return;
	          if (this.selectedVideoImageIds.includes(key)) {
	            this.selectedVideoImageIds = this.selectedVideoImageIds.filter((id) => id !== key);
	          } else {
	            this.selectedVideoImageIds = [...this.selectedVideoImageIds, key];
	          }
	        },
        selectedVideoRows() {
	          const selected = new Set(this.selectedVideoImageIds || []);
	          if (!selected.size) {
	            return [];
	          }
	          return (this.currentRookieRows || []).filter((row) => row.cost > 0 && selected.has(this.videoSelectKey(row)));
	        },
	        selectedVideoImageIdList() {
	          return Array.from(new Set(this.selectedVideoRows().map((row) => String(row.image_id)).filter(Boolean)));
	        },
	        clearVideoSelection() {
	          this.selectedVideoImageIds = [];
	        },
	        batchCancelSelectedVideo() {
	          const imageIds = this.selectedVideoImageIdList();
	          if (!imageIds.length) {
	            ElMessage.warning("请先在激励视频列勾选图片");
	            return;
	          }
          ElMessageBox.confirm(`确认取消选中 ${imageIds.length} 张图片的激励视频？同一图片在其他位置也会变为非激励。`, "取消激励视频", {
            type: "warning",
          }).then(() => {
            this.loading = true;
            return axios.post("/cms/v1/batch-tag", {
              ids: imageIds,
              mode: "add",
              cost: 0,
            });
          }).then(() => {
            const idSet = new Set(imageIds);
            (this.rookie || []).forEach((row) => {
              if (idSet.has(String(row.image_id))) {
                row.cost = 0;
              }
            });
	            (this.image_list || []).forEach((row) => {
	              if (idSet.has(String(row.id))) {
	                row.cost = 0;
	              }
	            });
	            this.clearVideoSelection();
	            this.formatData();
            ElMessage.success(`已取消 ${imageIds.length} 张图片的激励视频`);
          }).catch((e) => {
            if (!["cancel", "close"].includes(e)) {
              apiError(e);
            }
          }).finally(() => {
            this.loading = false;
          });
        },
        onBoardDragStart({ day, oldIndex }) {
          const dayData = this.data[day];
          this.onRookieDragStart(dayData, { oldIndex });
        },
        onBoardSelect(rookie) {
          const dayData = this.data[rookie.day];
          this.toggleRookieSelection(dayData, rookie);
        },
        onManualReorder({ day, from, to }) {
          const dayData = this.data[day];
          if (!dayData) {
            return;
          }
          const images = dayData.images || [];
          const state = this.groupDragState;

          if (state && state.groupKeys.length > 1 && state.dayKey === String(day)) {
            const keys = state.groupKeys;
            const keySet = new Set(keys);
            const groupRows = keys.map((key) => state.rowsByKey[key]).filter(Boolean);
            const withoutGroup = images.filter((row) => !keySet.has(this.rookieSelectKey(row)));

            const temp = [...images];
            const fromIdx = temp.findIndex((row) => this.rookieSelectKey(row) === state.draggedKey);
            if (fromIdx === -1) {
              this.resort(dayData);
              return;
            }
            const [dragged] = temp.splice(fromIdx, 1);
            let toIdx = to;
            if (fromIdx < toIdx) {
              toIdx--;
            }
            temp.splice(toIdx, 0, dragged);

            const afterKeys = temp.map((row) => this.rookieSelectKey(row));
            const draggedIndex = afterKeys.indexOf(state.draggedKey);
            const insertIndex = afterKeys
              .slice(0, draggedIndex)
              .filter((key) => !keySet.has(key))
              .length;

            const nextImages = [
              ...withoutGroup.slice(0, insertIndex),
              ...groupRows,
              ...withoutGroup.slice(insertIndex),
            ];
            images.splice(0, images.length, ...nextImages);
          } else {
            const [item] = images.splice(from, 1);
            images.splice(to, 0, item);
          }

          this.resort(dayData);
        },
        onRookieDragStart(dayData, evt) {
          const images = dayData && dayData.images ? dayData.images : [];
          const dragged = images[evt.oldIndex];
          const draggedKey = this.rookieSelectKey(dragged);
          const dayKey = this.rookieDayKey(dayData);
          if (!draggedKey) {
            this.groupDragState = null;
            return;
          }
          const selectedSet = new Set(this.selectedRookieIds || []);
          const selectedInThisDay = this.selectedRookieDay === dayKey && selectedSet.has(draggedKey);
          const groupKeys = selectedInThisDay
            ? images.map((r) => this.rookieSelectKey(r)).filter((key) => selectedSet.has(key))
            : [draggedKey];
          this.groupDragState = {
            dayKey,
            draggedKey,
            groupKeys,
            keepSelection: selectedInThisDay,
            rowsByKey: images.reduce((acc, row) => {
              acc[this.rookieSelectKey(row)] = row;
              return acc;
            }, {}),
          };
          if (!selectedInThisDay) {
            this.selectedRookieIds = [];
            this.selectedRookieDay = null;
          }
        },
        onRookieDragEnd() {
          this.groupDragState = null;
          this.suppressRookieClick = true;
          setTimeout(() => {
            this.suppressRookieClick = false;
          }, 0);
        },
        markSortDirty(day, images) {
          const key = String(day);
          this.pendingSortByDay = {
            ...this.pendingSortByDay,
            [key]: images.map((i) => i.id).filter((id) => !!id),
          };
          this.scheduleSortAutoSave();
        },
        clearSortAutoSave() {
          if (this.sortAutoSaveTimer) {
            clearTimeout(this.sortAutoSaveTimer);
            this.sortAutoSaveTimer = null;
          }
        },
        scheduleSortAutoSave() {
          this.clearSortAutoSave();
          this.sortAutoSaveTimer = setTimeout(() => {
            this.commitPendingSort({silent: true});
          }, 2000);
        },
        commitPendingSort(options = {}) {
          if (this.sortSavePromise) {
            return this.sortSavePromise;
          }
          this.clearSortAutoSave();
          const sortList = Object.values(this.pendingSortByDay).filter((sort) => sort && sort.length);
          if (!sortList.length) {
            return Promise.resolve(true);
          }
          const submittedSortByDay = {...this.pendingSortByDay};
          this.sortSaving = true;
          this.sortSavePromise = axios.all(
            sortList.map((sort) => axios.post(`/cms/v1/sort/country/manual`, { sort }))
          ).then(_ => {
            const remaining = {...this.pendingSortByDay};
            Object.entries(submittedSortByDay).forEach(([day, submittedSort]) => {
              const currentSort = remaining[day];
              if (JSON.stringify(currentSort) === JSON.stringify(submittedSort)) {
                delete remaining[day];
              }
            });
            this.pendingSortByDay = remaining;
            if (!options.silent) {
              ElMessage.success("排序已保存");
            }
            return true;
          }).catch((e) => {
            apiError(e);
            return false;
          }).finally(() => {
            this.sortSaving = false;
            this.sortSavePromise = null;
            if (this.hasPendingSort) {
              this.scheduleSortAutoSave();
            }
          });
          return this.sortSavePromise;
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const imagesToAdd = this.form.images.filter((image) => !this.isImageAddedToCurrentBucket(image));
                    const skippedCount = this.form.images.length - imagesToAdd.length;
                    if (!imagesToAdd.length) {
                      ElMessage.warning("选中的图片已在当前国家/方案/用户来源中，无需重复添加");
                      return;
                    }
                    if (skippedCount > 0) {
                      ElMessage.warning(`已跳过 ${skippedCount} 张重复图片`);
                    }
                    if (this.restorePreviewMode) {
                      this.loading = true;
                      const k = this.normSource(this.form.source);
                      const inDay = this.rookie.filter(
                        (r) => r.day === this.form.day
                          && this.rowSource(r) === k
                      );
                      let maxS = 0;
                      inDay.forEach((r) => { if ((r.sort || 0) > maxS) maxS = r.sort || 0; });
                      imagesToAdd.forEach((i, idx) => {
                        const row = this.assignSourceFields({
                          day: this.form.day,
                          image_id: String(i.id),
                          label: this.form.label,
                          country: this.form.country,
                          platform: this.form.platform,
                          thumbnail: i.thumbnail,
                          categories: i.categories,
                          cost: i.cost,
                          animation: i.animation,
                          online_date: i.online_date,
                          sort: maxS + 1 + idx,
                          _localOnly: true,
                        }, this.form.source);
                        this.rookie.push(row);
                      });
                      this.formatData();
                      this.refreshAdded();
                      this.reset();
                      this.loading = false;
                      return;
                    }
                    this.loading = true;
                    const reqs = [];
	                    imagesToAdd.forEach(i => {
	                      const data = {day: this.form.day, label: this.form.label, country: this.form.country, image_id: i.id,
	                        platform: this.form.platform};
	                      if (this.form.source) {
	                        data.source = this.form.source;
	                      }
	                      reqs.push(axios.post(`/cms/v1/country/manual`, data).then(res => {
	                        this.rookie.push({
	                          ...(res.data.data || {}),
	                          image_id: String(i.id),
	                          thumbnail: i.thumbnail,
	                          categories: i.categories,
	                          cost: i.cost,
	                          animation: i.animation,
	                          online_date: i.online_date,
	                        });
	                      }));
	                    });
	                    axios.all(reqs).then(_ => {
	                      this.formatData();
	                      this.refreshAdded();
	                      this.reset();
	                    }).catch((e) => {
                      apiError(e);
                    }).finally(() => {
                      this.loading = false;
                    });
                }
            })
        },
        remove(row) {
            this.removeRookieFromSelection(row);
            if (row && row._localOnly) {
              this.rookie = this.rookie.filter((x) => x !== row);
              this.formatData();
              this.refreshAdded();
              return;
            }
            if (!row || !row.id) {
              ElMessage.warning("无效数据，请刷新后重试");
              return;
            }
	            this.loading = true;
	            axios.delete(`/cms/v1/country/manual/${row.id}`).then(res => {
	                this.rookie = this.rookie.filter((x) => x.id !== row.id);
	                this.formatData();
	                this.refreshAdded();
	            }).catch((e) => { apiError(e); }).finally(() => { this.loading = false; });
        },
        addImage(image) {
          if (this.isImagePickedOrAdded(image)) {
            ElMessage.warning("该图片已在当前国家/方案/用户来源中，无需重复添加");
            return;
          }
          image.added = true
          this.form.images.push(image);
        },
        resort(dayData) {
            const images = dayData && dayData.images ? dayData.images : [];
            images.forEach((i, idx) => { i.sort = idx; });
            if (this.restorePreviewMode) {
              return;
            }
            this.markSortDirty(dayData.day, images);
        },
        df(map, list) {
            list.forEach(l => {
                map[l.id] = l.i18n_name?.ZH_HANS || l.name;
                if (!l.children) {
                    l.children = [];
                }
                if (l.children.length) {
                    this.df(map, l.children);
                }
            });
        },
        countryLabel(code) {
          if (!code) return '';
          const hit = (this.$root.country_list || []).find((c) => c && c.code === code);
          if (hit && hit.en_name) return `${hit.en_name} (${hit.code})`;
          return code;
        },
        addCountry(country) {
          if (country && country !== "US" && country !== "GLOBAL" && !this.countries.includes(country)) {
            this.countries.push(country);
          }
          if (country) {
            this.form.country = country === "GLOBAL" ? "US" : country;
            this.data = [];
            this.form.source = '';
          }
          this.init();
        },
        updateRookie(row, refresh) {
          if (this.restorePreviewMode) {
            this.formatData();
            this.refreshAdded();
            return;
          }
          if(refresh) {
            this.loading = true;
          }
          const body = this.withManualSource({
            image_id: row.image_id, day: row.day, platform: this.form.platform,
            label: this.form.label, country: this.form.country,
          }, this.form.source);
	          axios.put(`/cms/v1/country/manual`, body).then(_ => {
	            if(refresh) {
	              this.formatData();
	              this.refreshAdded();
	              this.loading = false
	            }
	          }).catch((e) => { apiError(e); if (refresh) this.loading = false; });
        },
        
    },
    computed: {
      isNonDefaultSource() {
        return !!(this.form.source && this.normSource(this.form.source));
      },
      canCommitSource() {
        return this.isNonDefaultSource && this.restorePreviewMode;
      },
      pendingSortCount() {
        return Object.keys(this.pendingSortByDay || {}).length;
      },
      hasPendingSort() {
        return this.pendingSortCount > 0;
      },
      selectedRookieCount() {
        return (this.selectedRookieIds || []).length;
      },
      selectedRookieIdSet() {
        return new Set(this.selectedRookieIds || []);
      },
	      selectedVideoCount() {
	        return this.selectedVideoImageIdList().length;
	      },
      /** 当前「平台+国家+方案」桶下：接口里已存在的非默认用户来源 + 本地新建空来源 */
      mergedSourceOptions() {
        const s = new Set();
        (this.sourceSuggestions || []).forEach((k) => { if (k) s.add(k); });
        (this.extraSources || []).forEach((k) => { if (k) s.add(k); });
        return Array.from(s).sort();
      },
      /** 用于用户来源下拉：随平台/国家/方案变化重挂载，避免残留上一桶的选中值 */
      manualBucketKey() {
        return `${this.form.platform || ''}|${this.form.country || ''}|${this.form.label != null ? this.form.label : ''}`;
      },
      displayDays() {
        return (this.data || []).filter(Boolean);
      },
      manualCdnUrl() {
        return this.$root.cdn_url || 'https://jigsaw-cdn.plutodesk.com';
      },
      rookieFilter() {
        return (this.currentRookieRows || []).filter(d => {
          if (this.isBoolFilterActive(this.rookieVideoFilter) && (d.cost > 0) !== this.rookieVideoFilter) return false;
          if (this.isBoolFilterActive(this.rookieAnimationFilter) && this.hasAnimation(d) !== this.rookieAnimationFilter) return false;
          if (this.form.category_ids && this.form.category_ids.length > 0) {
            return d.categories && d.categories.some(c => this.form.category_ids.includes(c));
          }
          return true;
        })
      },
      pagedRookieFilter() {
        const start = (this.rookieTablePage - 1) * this.rookieTablePageSize;
        return this.rookieFilter.slice(start, start + this.rookieTablePageSize);
      },
    },
    watch: {
      "form.label"() {
        if (this._skipBucketWatchReset) return;
        this.extraSources = [];
        this.defaultRookieCache = [];
        this._defaultRookieBox = null;
      },
      "form.country"() {
        if (this._skipBucketWatchReset) return;
        this.extraSources = [];
        this.defaultRookieCache = [];
        this._defaultRookieBox = null;
      },
      "form.platform"() {
        if (this._skipBucketWatchReset) return;
        this.extraSources = [];
        this.defaultRookieCache = [];
        this._defaultRookieBox = null;
      },
      rookieVideoFilter() {
        this.resetRookieTablePage();
      },
      rookieAnimationFilter() {
        this.resetRookieTablePage();
      },
      "form.category_ids"() {
        this.resetRookieTablePage();
      },
      rookieFilter() {
        const maxPage = Math.max(1, Math.ceil(this.rookieFilter.length / this.rookieTablePageSize));
        if (this.rookieTablePage > maxPage) {
          this.rookieTablePage = maxPage;
        }
      },
    },
    mounted() {
        this.loading = true;
        axios.all([
            axios.get(`/cms/v1/category`).then(res => {
                this.category_list = res.data.data.categoryList.filter(c => !['ALL', 'COLLECTION'].includes(c.key));
                this.category_list.forEach(c => {
                    this.category_map[c.id] = c.i18n_name.ZH_HANS;
                });
            }),
            axios.get('/cms/v1/tag/major').then(res => {
                this.major_list = res.data.data.tagList;
                this.convertTagNames(this.major_list);
                this.df(this.major_map, this.major_list);
            }),
            axios.get('/cms/v1/tag/minor').then(res => {
                this.minor_list = res.data.data.tagList;
                this.convertTagNames(this.minor_list);
                this.df(this.minor_map, this.minor_list);
            }),
            axios.get('/cms/v1/tag/assistant').then(res => {
                this.assistant_list = res.data.data.tagList;
                this.convertTagNames(this.assistant_list);
                this.df(this.assistant_map, this.assistant_list);
            }),
            axios.get('/cms/v1/source').then(res => {
                this.source_list = [];
                res.data.data.sourceList.forEach(s => {
                    if (s && !this.source_list.includes(s)) {
                        this.source_list.push(s);
                    }
                });
            }),
            // this.loadImage(),
        ]).then(_ => {
            this.init();
        })
    },
    beforeUnmount() {
      this.clearSortAutoSave();
    },
}
</script>

<style scoped>
.cm-restore-bar {
  margin-bottom: 10px;
}
.cm-filter-header {
  display: flex;
  align-items: center;
  gap: 6px;
}
.cm-import-file {
  margin-left: 10px;
  color: var(--el-text-color-secondary);
  font-size: 13px;
}
.cm-rookie-table-pagination {
  margin-top: 10px;
}
.el-select {
  width: 200px;
}
/* 默认用户来源的值为空字符串，Element Plus 会当 placeholder；改成和平台/方案选中态同色 */
:deep(.cm-source-select:not(.is-disabled) .el-input__inner) {
  color: var(--el-text-color-regular);
}
:deep(.cm-source-select:not(.is-disabled) .el-input__inner::placeholder) {
  color: var(--el-text-color-regular);
  -webkit-text-fill-color: var(--el-text-color-regular);
}
:deep(.cm-source-select:not(.is-disabled) .el-select__placeholder),
:deep(.cm-source-select:not(.is-disabled) .el-select__selected-item) {
  color: var(--el-text-color-regular);
}
:deep(.el-cascader__tags) {
    flex-wrap: nowrap;
}
</style>
